<template>
  <div id="footers" class="footers">
    <!-- 公司项目 工作时间 联系电话 地址 备案 二维码 -->
    <div class="company">
      <div v-if="mobileShow && $route.path !=='/home'" class="professional_team">
        <!-- <img src="../assets/home/25.png" alt=""> -->
        <ul style="display: flex; width: 1200px; margin: 0 auto">
          <li>
            100
            <span>+</span>
            <p>资质荣誉</p>
          </li>
          <li>
            700
            <span>+</span>
            <p>专家团队</p>
          </li>
          <li>
            10
            <span>万+</span>
            <p>服务客户</p>
          </li>
          <li>
            40
            <span>+</span>
            <p>业务领域</p>
          </li>
          <li>
            3
            <span>万平+</span>
            <p>智能实验室</p>
          </li>
        </ul>
      </div>
      <div class="companyInfo">
            <div class="company_list_logo">
              <img class="companyInfo_name" src="../assets/home/logo_footer_1221.png" alt="">
              <p class="companyInfo_title">第三方综合检测平台</p>
              <div v-if="!mobileShow" style="border-top: 1px solid #fff; opacity: 0.1;margin-bottom: 20px"></div>
              <div class="companyInfo_address" :style="{ marginTop: (mobileShow ? '24px' : '') }">
                <span
                  class="hotphone"
                >
                  服务热线
                </span>
                <span
                  class="hotphone-num"
                >
                  （ 7*24小时专线服务 ）
                </span>
              </div>
              <div class="companyInfo_address" style="margin-top: 6px">
                <span class="companyInfo_phone">400-800-2318</span>
              </div>
              <div class="or_code">
                <div style="margin-right: 40px">
                  <img :src="$path + orcode_url1" alt="" />
                  <p style="margin-top:5px;">{{orcode_title1}}</p>
                </div>
                <div>
                  <img :src="$path + orcode_url2" alt="" />
                  <p style="margin-top:5px;">{{orcode_title2}}</p>
                </div>
              </div>
            </div>
            <div class="company_list_cont">
            <div
              class="company_list company_ph"
            >
              <div class="company_list_name" @click="handleClick()">
                {{ industryCompanyList.name }}
                  <span class="isDownMenu">
                    <img v-if="isFooterShow && footerCurrent === index" src="../assets/home/mobile/down@2x.png" alt="">
                    <img v-else src="../assets/home/mobile/_@2x.png" alt="">
                  </span>
              </div>
              <div
                style="margin-right: 20px"
                :class="isFooterShow && footerCurrent === index
                    ? 'company_list_children1 m_company_list_click'
                    : 'company_list_children1 m_company_list_close'"
              >
                <p
                  class="company_list_children_name"
                  v-for="(it, i) in industryCompanyList.children"
                  :key="i"
                  @click="navto(it)"
                  style="margin-right: 20px"
                >
                  {{ it.name }}
                </p>
              </div>
            </div>
            <div
              class="company_list"
              v-for="(item, index) in companyList"
              :key="index"
            >
              <div class="company_list_name" @click="handleClick(index)">
                {{ item.name }}
                  <span class="isDownMenu">
                    <img v-if="isFooterShow && footerCurrent === index" src="../assets/home/mobile/down@2x.png" alt="">
                    <img v-else src="../assets/home/mobile/_@2x.png" alt="">
                  </span>
              </div>
              <div
                :class="isFooterShow && footerCurrent === index
                    ? 'company_list_children1 m_company_list_click'
                    : 'company_list_children1 m_company_list_close'"
              >
                <p
                  class="company_list_children_name"
                  v-for="(it, i) in item.children"
                  :key="i"
                  @click="navto(it)"
                >
                  {{ it.name }}
                </p>
              </div>
            </div>
            </div>
      </div>
      <div class="footer-line"></div>
      <div style="padding-top: 24px;padding-bottom: 26px;">
        <ul class="footer">
          <li class="footer_cont">
            <a style="color:#fff" href="http://beian.miit.gov.cn" target="_blank">Copyright &copy; 2019 西安国联信息科技有限责任公司版权所有 陕ICP备19025530号.</a>
          </li>
          <li class="footer_copyright2">
            <img src="../assets/home/copyright.png" alt="">
            <span>全国涉黑涉恶违法犯罪线索举报</span>
          </li>
        </ul>
        <div class="footer" style="margin-top:10px;">
          <div class="footer_cont" style="margin-right:0;">
            <span>利用信息网络威胁他人，强迫交易、利用网络辱骂、恐吓他人或编造、散布虚假信息破坏社会秩序或公共秩序、寻衅滋事、利用网络实施黄赌毒、暴力传销、高利放贷、非法讨债</span>
            <a style="color:#fff" href="https://www.12389.gov.cn/clue_evilNotice.action" target="_blank">  立即举报</a>
          </div>
        </div>
      </div>
    </div>
    <div class="m_footer-block" style="height: 50px">

    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: "",
  data() {
    return {
      status: false,
      isFooterShow: false,
      footerCurrent: 0,
      orcode_url1: '',
      orcode_url2: '',
      orcode_title1: '',
      orcode_title2: '',
      busService: [],
      industryCompanyList: {
        name: "行业方案",
        cssStatus: 1,
        children: [],
      },
      companyList: [
        {
          name: "业务服务",
          cssStatus: 2,
          children: [],
        },
        {
          name: "实用工具",
          cssStatus: 1,
          children: [
            {
              id: "1",
              name: "报告验证",
              path: "http://glpc.xaunqd.com/verification/index.html",
              flag: true
            },
            {
              id: "10402",
              name: "政策解读",
              path: "/utilitytools",
            },
            {
              id: "10403",
              name: "资料下载",
              path: "/utilitytools",
            },
            {
              id: "10401",
              name: "质检科普",
              path: "/utilitytools",
            },
            {
              id: "104012222222",
              name: " 订单及报告查询",
              path: "http://gjl.customer.guojianlian.cn/",
            },
          ],
        },
        {
          name: "友情链接",
          cssStatus: 2,
          children: [],
        },
      ],
      sitedata: {},
      dominNum: '陕ICP备12001835号-1'
    };
  },
  computed: {
    ...mapState(['screenWidth']),
    mobileShow() {
      if (this.screenWidth < 1000) {
          return false
      } else {
          return true
      }
    }
    },
  created() {
    const domain = window.location.host
    if (domain.indexOf('xaunqd.com')) {
      this.dominNum = '陕ICP备12001835号-1'
    } else if (domain.indexOf('unqdtest.com') || domain.indexOf('guojianlian.cn')) {
      this.dominNum = '陕ICP备12001835号-2'
    } else if (domain.indexOf('unqdoil.com')) {
      this.dominNum = '陕ICP备12001835号-3'
    } else if (domain.indexOf('unqdfenxi.com')) {
      this.dominNum = '陕ICP备12001835号-4'
    } else if (domain.indexOf('huagongjiance.com') || domain.indexOf('glzj315.cn') || domain.indexOf('glzj315.net') || domain.indexOf('glzj315.com') || domain.indexOf('huanjingjiance.org') || domain.indexOf('youpinjiance.com') || domain.indexOf('cailiaojiance.com.cn')) {
      this.dominNum = '陕ICP备12001835号-7'
    }
    this.$api.iotHome
      .getSite({
        siteType: "0",
        type: "0",
      })
      .then((res) => {
        if (res.data.success == true) {
          this.sitedata = res.data.data;
        }
      });
    this.$api.iotHome.friendLink().then((res) => {
      // console.log(res);
      if (res.data.success == true) {
        this.navList = res.data.data;
      }
    });
    this.$api.iotHome
      .getImageList({
        columnId: "1114",
      })
      .then((res) => {
        if (res.data.success == true) {
          this.orcode_url1 = res.data.data.list[0].image;
          this.orcode_url2 = res.data.data.list[1].image;
          this.orcode_title1 = res.data.data.list[0].title;
          this.orcode_title2 = res.data.data.list[1].title;
          // window.localStorage.setItem('orCode_img', this.orcode_url1)
          // window.localStorage.setItem('orCode_title', this.orcode_title1)
          this.$store.commit("changeOrCodeImg", this.orcode_url1);
          this.$store.commit("changeOrCodeTitle", this.orcode_title1);
        }
      });
    // 业务服务
    this.$api.iotHome
      .getServiceList({
        type: 1
      })
      .then(res => {
         if (res.data.success == true) {
           this.companyList[0].children = res.data.data;
            this.companyList[0].children.map(item => {
              item.path = '/services'
            })
         }
      })
    // 行业方案
      this.$api.iotHome
        .typelist({
          id: "",
          siteId: "0",
        })
        .then((res) => {
          if (res.data.success == true) {
            this.industryCompanyList.children = res.data.data;
            this.industryCompanyList.children.map(item => {
              item.path = '/detection'
            })
          }
        });
    // 友情链接
    this.$api.iotHome
      .getFriendLinkData()
      .then(res => {
         if (res.data.success == true) {
           this.companyList[2].children = res.data.data.map(item=>{
             return {name:item.name,path:item.url}
           });
         }
      })
  },
  methods: {
    // 底部点击
    handleClick(index) {
        this.isFooterShow = !this.isFooterShow
        this.footerCurrent = index
    },
    // 导航的路由跳转
    navto(data) {
      window.localStorage.setItem("defaultActive", data.id);
      if (data.path === '/utilitytools' || data.path === '/services') {
        this.$router.push({
          path: data.path,
          query: {
            columnId: data.id
          },
        });
      } else {
        if (data.path.indexOf('http') > -1) {
          if (document.documentElement.clientWidth < 900) {
            if (data.flag) {
              this.$notify({
                message: '请在电脑端进行查询',
                // position: 'top-left',
                type: 'warning',
                offset: 100
              })
            } else {
              window.open(data.path)
            }
          } else {
            window.open(data.path)
          }
        } else {
          if (data.path == this.$route.path + "/") {
            this.$router.go(0);
          } else {
            this.$router.push({
              path: data.path,
              query: {
                id: data.id
              },
            });
          }
        }
      }
    },
    footerto(data) {
      window.localStorage.setItem("defaultActive", data.id);
      this.$router.replace({
        path: data.path,
      });
    },
    navtolist(data) {
      window.open(data.url);
    },
    // 图片放大
    previewImg(url) {
      this.$hevueImgPreview(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.hotphone {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
}
.hotphone-num {
  color: #ffffff;
  opacity: 0.5;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.professional_team {
  width: 100%;
  height: 175px;
  background-color: #161E30;
  ul {
    color: #fff;
    font-family: PingFangSC;
    justify-content: space-between;
    border-bottom: 1px solid #4F4F4F;
    padding-bottom: 27px;
    li {
      font-size: 50px;
      text-align: center;
      span {
        font-size: 25px;
        margin-left: -10px;
      }
      p {
        font-size: 25px;
      }
    }
  }
}
// .professional_team img {
//   margin: 0 auto 40px auto;
// }
.footers {
  z-index: 1111;
  position: relative;
  background: #161e30;
}
.footer-line {
  width: 1200px;
  border-bottom: 1px solid #fff;
  opacity: 0.1;
  margin: 20px auto 0 auto;
}

.footer {
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  width: 1200px;
  opacity: 0.5;
  margin: 0 auto;
  justify-content: center;
}
.footer_copyright {
  margin-right: 24px;
}
.footer_copyright, .footer_copyright2 {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.footer_copyright img, .footer_copyright2 img {
  margin-right: 8px;
}
.footer_cont {
  font-size: 14px;
  color: #ebeef5;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  margin-right: 63px;
}

.font-color {
  font-size: 16px;
  color: #ebeef5;
}

.company {
  width: 100%;
  padding-top: 40px;
}

.companyInfo {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}

.companyInfo_name {
  padding: 0;
  margin: 0;
  font-size: 40px;
  font-weight: 700;
  color: #ffffff;
  cursor: default;
}

.companyInfo_title {
  margin-top: 10px;
  color: #ffffff;
  cursor: default;
  opacity: 0.5;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}

.companyInfo_address {
  font-size: 14px;
  color: #ffffff;
  cursor: default;
}

.companyInfo_phone {
  margin-top: 5px;
  cursor: default;
  font-size: 24px;
  font-family: DIN-Medium;
  font-weight: 500;
}

.companyInfo_ba {
  font-size: 12px;
  color: #ffffff;
  line-height: 26px;
  cursor: default;
}

.companyInfo_ba > a {
  font-size: 12px;
  color: #ffffff;
}
.company_list_logo {
  margin-right: 150px;
}
.company_list_cont{
  width: 70%;
  display: flex;
  justify-content: space-between;
}
.company_list_box {
}
.company_list {
  margin-bottom: 16px;
  margin-right: 50px;
}

.company_list_children1 {
  margin-top: 8px;
  opacity: 0.5;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #fff;
  line-height: 30px;
  height: 300px;
  display: flex;
  flex-flow: wrap;
  flex-direction: column;
}

.company_list_children_name {
  font-size: 14px;
  color: #e4e7ed;
  cursor: pointer;
}

.company_list_children_name:hover {
  color: #fff;
}
.company_ph {
  width: 220px;
}
.company_list_name {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fff;
}
.children_name1 {
  width: 16%;
}

.or_code {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.or_code > div {
  text-align: center;
}

.text_nav:hover {
  color: #0076c6 !important;
}

.or_code img {
  width: 96px;
  height: 96px;
}

.or_code > div > p {
  color: #ffffff;
  cursor: default;
  opacity: 0.5;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
}

.el-image {
  width: 100% !important;
  height: 100% !important;
}
.isDownMenu {
  display: none;
}
@media screen and (max-width: 1000px) {
  .isDownMenu {
    display: block;
    width: 16px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .company {
    padding: 24px 16px;
  }
  .companyInfo {
    width: 100%;
    flex-direction:column-reverse;
  }
  .company_ph {
    width: 100%;
  }
  .footer {
    width: 100% !important;
    text-align: left;
    display: block;
  }
  .footer-line {
    width: 1200px;
    border-bottom: 1px solid #fff;
    opacity: 0.1;
    width: 100%;
    margin-top: 10px;
  }
  .footer_cont {
    color: #ebeef5;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    padding: 16px 0;
  }
  .footer_copyright, .footer_copyright2 {
      color: #fff;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      margin-right: 0;
      text-align: left;
  }
  .company_list {
    width: 100%;
  }
  .company_list_children1 {
    margin-top: 8px;
    opacity: 0.5;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #fff;
    line-height: 30px;
    height: auto;
    display: flex;
}
  .footer_copyright img, .footer_copyright2 img {
    margin-right: 4px;
  }
  .company_list_cont {
    width: 100%;
    flex-direction:column;
  }
  .company_list_logo {
    width: 100%;
  }
  .company_list {
    text-align: left;
  }
  .company_list_name {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    opacity: 0.8;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .company_list_children_name {
    opacity: 0.5;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
  }
  .companyInfo_title {
    display: none;
  }
  .companyInfo_name {
    display: none;
  }
  .hotphone {
    opacity: 0.8;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
  }
  .hotphone-num {
    opacity: 0.5;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
  }
  .companyInfo_phone {
    font-size: 20px;
    font-family: ChanNumber;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
  }
  .or_code {
    div {
      img {
        width: 80px;
        height: 80px;
        margin-top: 12px;
      }
      p {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
}
.m_company_list_click {
  display: block;
}
.m_company_list_close {
  display: none;
}
}
@media screen and (min-width: 960px) {
  .m_footer-block{
    display: none;
  }
}
</style>
